import type { ReactNode } from 'react';
import { FileText } from 'lucide-react';
import { Badge, DetailPageHeader } from '@/shared/components';
import type { DocumentTemplateDetail } from '../types/documentTemplates.types';
import { formatDay } from '../utils/versionLabels';
import { DeleteTemplateAction } from './DeleteTemplateAction';
import { TemplateCustomiseAction } from './TemplateCustomiseAction';
import { TemplateProvenanceBanner } from './TemplateProvenanceBanner';

interface Props {
  template: DocumentTemplateDetail;
  isInternal: boolean;
  canManage: boolean;
  tabs?: ReactNode;
}

export function TemplateDetailHeader({ template, isInternal, canManage, tabs }: Props) {
  return (
    <DetailPageHeader
      breadcrumbs={[{ label: 'Document templates', to: '/admin/document-templates' }, { label: template.name }]}
      title={template.name}
      icon={FileText}
      tabs={tabs}
      badges={
        <>
          {template.published && <Badge variant="success">Live v{template.published.versionNumber}</Badge>}
          {template.hasDraft && <Badge variant="warning">Draft</Badge>}
        </>
      }
      subtitle={template.updatedAt ? `Updated ${formatDay(template.updatedAt)}` : undefined}
      actions={
        <>
          {canManage && <DeleteTemplateAction templateId={template.id} templateName={template.name} />}
          <TemplateCustomiseAction template={template} isInternal={isInternal} />
        </>
      }
    >
      {template.source && <TemplateProvenanceBanner source={template.source} />}
    </DetailPageHeader>
  );
}
